import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { trackPageView } from '../utils/gt';
import { listKeys } from '../utils/legal';

import { LegalDoc } from '../components/LegalDoc';

// Keys under pages.Terms, in reading order (the titles carry the section numbers)
const sections = [
  { title: 's1Title', text: 's1Text' },
  { title: 's2Title', text: 's2Text', items: listKeys('s2Item', 4) },
  { title: 's3Title', text: 's3Text' },
  {
    title: 'privacyTitle',
    text: 'privacyText',
    link: { to: '/privacy', label: 'privacyLink' },
  },
  { title: 'proTitle', text: 'proText', items: listKeys('proItem', 5) },
  { title: 's4Title', text: 's4Text' },
  { title: 's5Title', text: 's5Text' },
  { title: 'alexaTitle', text: 'alexaText' },
  { title: 'linksTitle', text: 'linksText' },
  { title: 's6Title', text: 's6Text' },
  { title: 'licensesTitle', text: 'licensesText', items: listKeys('licensesItem', 4) },
  { title: 's7Title', text: 's7Text' },
  { title: 's8Title', text: 's8Text' },
  { title: 's9Title', text: 's9Text' },
  { title: 's10Title', text: 's10Text' },
  { title: 's11Title', text: 's11Text', mail: 'text' },
];

export const Terms = () => {
  const { t } = useTranslation();

  useEffect(() => {
    trackPageView('terms', `${t('appUrl')}/terms`, '/terms');
  }, [t]);

  return <LegalDoc page="Terms" sections={sections} hasClosing />;
};
